import { sortBy } from "lodash";
import moment from "moment";

import {
  type MetricDataData,
  type TileDescriptor,
} from "@features/metrics-explorer/types";
import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";
import { convertStartDateToTimeZone } from "@north-beam/nb-common";

export function tileToExportData({
  tile,
  metric,
  metricData,
  timezone,
}: {
  tile: TileDescriptor;
  metric: SalesMetricV2;
  metricData: MetricDataData;
  timezone: string;
}) {
  const result: Record<string, string>[] = [];
  const name = tile.name || metric.name;

  for (const row of metricData.rows) {
    const date = moment(convertStartDateToTimeZone(row.date ?? "", timezone));

    let value = metric.getValue(row.metrics) ?? 0;

    if (Math.abs(value) < 1e-6 || value === Infinity) {
      value = 0;
    }

    result.push({
      date: date.format("YYYY-MM-DD"),
      [name]: String(value),
    });
  }

  return sortBy(result, [(e) => moment(e.date)]);
}
